import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router';
import { Spin } from 'antd';

const ShareAcceptPage: React.FC = () => {
    const { shareId } = useParams<{ shareId: string }>();
    const navigate = useNavigate();

    useEffect(() => {
        if (shareId) {
            // Store the shareId in sessionStorage so it persists after login
            sessionStorage.setItem('pendingShareId', shareId);
            
            // Check if user is logged in
            const token = localStorage.getItem('token');
            
            if (token) {
                // User is logged in, redirect to home page
                // The home page will check for pendingShareId and show the dialog
                navigate('/', { replace: true });
            } else {
                // User is not logged in, redirect to login page
                // After login, user will be redirected to home page which will show the dialog
                navigate('/login', { replace: true });
            }
        }
    }, [shareId, navigate]);

    return (
        <div className="flex items-center justify-center min-h-screen">
            <Spin size="large" tip="Processing share link..." />
        </div>
    );
};

export default ShareAcceptPage;
